
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fixedButtonWrapper: null,
      aspotButtonWrapper: null,
      ctaButtonWrapper: null,
      mainButton: null,
      videoLoaded: false,
      isMobile: {},
    }
  },
  watch: {
    videoLoaded() {
      if (this.videoLoaded) {
        this.$refs?.video.play()
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('sm')) {
        this.initButtonFlip()
      }
      this.initAnimation()

      // this.isMobile = {
      //   Android() {
      //     return navigator.userAgent.match(/Android/i)
      //   },
      //   BlackBerry() {
      //     return navigator.userAgent.match(/BlackBerry/i)
      //   },
      //   iOS() {
      //     return navigator.userAgent.match(/iPhone|iPad|iPod/i)
      //   },
      //   Opera() {
      //     return navigator.userAgent.match(/Opera Mini/i)
      //   },
      //   Windows() {
      //     return (
      //       navigator.userAgent.match(/IEMobile/i) ||
      //       navigator.userAgent.match(/WPDesktop/i)
      //     )
      //   },
      //   any() {
      //     return (
      //       this.isMobile.Android() ||
      //       this.isMobile.BlackBerry() ||
      //       this.isMobile.iOS() ||
      //       this.isMobile.Opera() ||
      //       this.isMobile.Windows()
      //     )
      //   },
      // }
      // console.log(this.isMobile.any())

      // if (!isMobile.any()) {
      //   // get reference to video sources
      //   const sources = document.getElementsByClassName('video__source')

      //   // loop through and replace data-src with src
      //   for (let i = 0; i < sources.length; i++) {
      //     if (sources[i].getAttribute('data-src')) {
      //       sources[i].setAttribute('src', sources[i].getAttribute('data-src'))
      //       sources[i].removeAttribute('data-src') // use only if you need to remove data-src attribute after setting src
      //     }
      //   }

      //   // fade in video from css when it's ready to play
      //   const video = document.getElementById('video')

      //   // listen for canplay event and fade video in
      //   video.addEventListener('canplay', function () {
      //     // console.log('video duration information available');
      //     video.style.transition = 'opacity 2s'
      //     video.style.opacity = 1
      //   })

      //   // reload video sources
      //   video.load()
      // }
    })
  },
  methods: {
    initAnimation() {
      const mm = this.$gsap.matchMedia(this.$refs.container)

      mm.add('(min-width: 1024px)', () => {
        this.$gsap.set([this.$refs.contentContainer], {
          transformOrigin: 'center',
        })

        // main column
        const tl = this.$gsap.timeline().from(this.$refs.content, {
          // transformOrigin: 'center ',
          // scale: 1.3,
          x: -80,
          opacity: 0,
          duration: 0.8,
          ease: 'back.out(.5)',
        })

        // parallax
        this.$gsap
          .timeline({
            scrollTrigger: {
              scrub: true,
            },
            onStart() {
              // fast forward initial reveal
              tl.progress(1)
            },
          })
          .to(this.$refs.contentContainer, {
            y: (i, target) =>
              -this.$ScrollTrigger.maxScroll(window) * target.dataset.speed,
            ease: 'none',
          })

          .to(
            '.heading-text',
            {
              // opacity: 0,
              duration: 0.5,
            },
            0
          )
      })
    },
    initButtonFlip() {
      this.fixedButtonWrapper = document.querySelector('#fixed__btn-wrapper')
      this.aspotButtonWrapper = document.querySelector(
        '.summit-aspot__cta-wrapper'
      )
      this.ctaButtonWrapper = document.querySelector('.cta-button__wrapper')
      this.mainButton = this.$refs?.cta.$el

      // When scrolling out-of and back-into the hero
      this.$ScrollTrigger.create({
        trigger: this.aspotButtonWrapper,
        start: 'bottom center',
        end: 'bottom bottom',
        // markers: true,
        onLeave: () => this.moveButtonInto(this.fixedButtonWrapper),
        onEnterBack: () => this.moveButtonInto(this.aspotButtonWrapper),
      })

      // When scrolling into and then back-out-of the cta section
      this.$ScrollTrigger.create({
        trigger: this.ctaButtonWrapper,
        start: 'top bottom-=5%',
        end: 'bottom bottom-=10%',
        // markers: true,
        onEnter: () => this.moveButtonInto(this.ctaButtonWrapper),
        onLeaveBack: () => this.moveButtonInto(this.fixedButtonWrapper),
      })
    },
    moveButtonInto(element) {
      if (!element) return

      const state = this.$Flip.getState(this.mainButton)
      element.prepend(this.mainButton)

      // find closest layout container and remove overflow-hidden
      // this will allow the button to be visible when it's outside of the layout container
      const layoutContainer = element.closest('.section__mask')

      if (layoutContainer) {
        layoutContainer?.classList.remove('overflow-hidden')
        layoutContainer?.classList.add('overflow-visible')
      }

      const targetBtn = this.mainButton.querySelector('.cta')

      // change state
      if (element === this.fixedButtonWrapper) {
        this.$gsap.to(targetBtn, {
          color: '#fff',
          backgroundColor: 'rgb(242, 92, 35)',
          duration: 0.3,
        })
      } else {
        this.$gsap.to(targetBtn, {
          color: 'rgb(242, 92, 35)',
          backgroundColor: '#fff',
          duration: 0.3,
        })
      }

      // animate flip
      this.$Flip.from(state, {
        zIndex: 100,
        scale: true,
        absolute: true,
        duration: 1.2,
        ease: 'power4.out',
        onComplete: () => {
          layoutContainer?.classList.remove('overflow-visible')
          layoutContainer?.classList.add('overflow-hidden')
        },
      })
    },
  },
}
